import { QueryFunction, useQuery } from 'react-query';
import {
    getAllSites,
    GetMonthlySiteParams,
    getMonthlySites,
    getSiteExpensesByDateRange,
    GetSiteExpensesParams,
    GetSitesQueries,
    MonthlySite,
    Site,
    SiteExpensesResponse,
} from '../../services/apiSLTP/sites/sites';

type UseSitesQueryOptions = {
    queries?: GetSitesQueries;
};

const getSites: QueryFunction<Site[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseSitesQueryOptions];
    const { queries } = options;

    const response = await getAllSites(queries);
    return response.data;
};

export const useSitesQuery = (options: UseSitesQueryOptions) => {
    return useQuery(['sites', options], getSites);
};

type UseMonthlySitesQueryOptions = {
    params: GetMonthlySiteParams;
};

const getMonthlySitesQuery: QueryFunction<MonthlySite[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMonthlySitesQueryOptions];
    const { params } = options;

    const response = await getMonthlySites(params);
    return response.data;
};

export const useMonthlySitesQuery = (options: UseMonthlySitesQueryOptions) => {
    return useQuery(['monthly sites', options], getMonthlySitesQuery);
};

type UseSiteExpensesQueryOptions = {
    queries: GetSiteExpensesParams;
};

const getSiteExpensesQuery: QueryFunction<SiteExpensesResponse['data']> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseSiteExpensesQueryOptions];
    const { queries } = options;

    const response = await getSiteExpensesByDateRange(queries);
    return response.data;
};

export const useSiteExpensesQuery = (options: UseSiteExpensesQueryOptions) => {
    return useQuery(['site expenses', options], getSiteExpensesQuery);
};
